import React from 'react'
import PropTypes from 'prop-types'

import { Box, CircularProgress, Typography } from '@mui/material'

import {
  StyledBoxCards,
  StyledCard,
  StyledCardContent,
  StyledContainerCards,
} from './style'
import { Link } from 'react-router-dom'

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import SessionBody from './bodyCard/sessionBody'
import ActionCard from './actionCard'

const CardMode = ({
  loadingData,
  dataList,
  titleOnglet,

  setRowElement,
  setOpenCancel,
  fetchDataById,
  setOpenModal,
  setIsEditAction,
  setOpenModelDelete,

  isSession,
}) => {
  return (
    <StyledContainerCards>
      {/* CARD STARTS  */}

      {loadingData ? (
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress sx={{ color: '#1976D2' }} />
        </Box>
      ) : dataList.length > 0 ? (
        dataList.map((el, index) => (
          <StyledBoxCards key={index}>
            <Link
              id={index}
              key={`${titleOnglet}_${index}`}
              to={`${titleOnglet}/${el.id}`}
              style={{ color: 'inherit', textDecoration: 'inherit' }}
              onClick={(event) => {
                event.stopPropagation()
              }}
            >
              <StyledCard>
                <StyledCardContent>
                  {isSession && <SessionBody row={el} />}
                  <ActionCard
                    row={el}
                    titleOnglet={titleOnglet}
                    setRow={setRowElement}
                    setOpenCancel={setOpenCancel}
                    fetchDataById={fetchDataById}
                    setOpenModal={setOpenModal}
                    setIsEditAction={setIsEditAction}
                    setOpenModelDelete={setOpenModelDelete}
                  />
                </StyledCardContent>
              </StyledCard>
            </Link>
          </StyledBoxCards>
        ))
      ) : (
        <Box sx={{ display: 'flex', margin: 'auto', width: 'fit-content' }}>
          <ErrorOutlineIcon style={{ margin: 'auto 5px', fontSize: '20px' }} />
          <Typography
            sx={{
              lineHeight: '1.5',
              letterSpacing: '0.00938em',
              fontSize: '18px',
            }}
            variant="h1"
          >
            Pas de données
          </Typography>
        </Box>
      )}

      {/* CARD ENDS  */}
    </StyledContainerCards>
  )
}
CardMode.propTypes = {
  loadingData: PropTypes.bool,
  dataList: PropTypes.array,
  titleOnglet: PropTypes.string,

  setRowElement: PropTypes.func,
  setOpenCancel: PropTypes.func,
  fetchDataById: PropTypes.func,
  setOpenModal: PropTypes.func,
  setIsEditAction: PropTypes.func,
  setOpenModelDelete: PropTypes.func,

  isSession: PropTypes.bool,
}
export default CardMode
